import { RealTimeAction } from '@/_core/fluxstore/types';
import { StorymapState } from '../../types';
import { useStorymapStore } from '../../useModule';
import dateFormat from 'date-fns/format';
import { ChangeReleaseDates as ChangeReleaseDatesCommand } from '@/api/releaseDetails/commands';
import { useSendCommand } from '@/_core/cqrs/use';

const { registerReducer, registerMiddleware } = useStorymapStore();

export class ChangeReleaseDates extends RealTimeAction<StorymapState> {
    public static ACTION_TYPE = 'ChangeReleaseDates';
    public startDate: string;
    public endDate: string;

    public constructor(public id: string, startDate: Date, endDate: Date) {
        super(ChangeReleaseDates.ACTION_TYPE);

        this.startDate = dateFormat(startDate <= endDate ? startDate : endDate, 'yyyy-MM-dd');
        this.endDate = dateFormat(endDate >= startDate ? endDate : startDate, 'yyyy-MM-dd');
    }
}

const middleware = async (state: StorymapState, action: ChangeReleaseDates): Promise<boolean> => {
    useSendCommand(action, {
        createCommand: () => new ChangeReleaseDatesCommand(state.id, action.id, action.startDate, action.endDate),
    });

    return true;
};

const reducer = (state: StorymapState, action: ChangeReleaseDates): void => {
    const release = state.releases.find((x) => x.id === action.id);

    release.startDate = action.startDate;
    release.releaseDate = action.endDate;
};

//@ts-ignore
registerMiddleware(ChangeReleaseDates.ACTION_TYPE, middleware);

//@ts-ignore
registerReducer(ChangeReleaseDates.ACTION_TYPE, reducer);
